<template>
    <div>
        <template v-if="singleTobObj.devcBaseInfoFalg">
            <div class="content-caption dashed">
                <span>设备基础信息</span>
            </div>
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产描述全称</label>
                    </div>
                    <div class="form-value">
                        <el-tag type="success" v-if="shopDeviceSubNo.suitMainFlag">主</el-tag>
                        <el-tag type="warning" v-if="shopDeviceSubNo.tagMissing">缺码</el-tag>
                        <span :title="shopDeviceSubNo.title || '无' ">{{shopDeviceSubNo.title || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产名称</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDeviceSubNo.name || '无' ">{{shopDeviceSubNo.name || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>品牌</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDeviceSubNo.brandName || '无' ">{{shopDeviceSubNo.brandName || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>型号</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDeviceSubNo.model || '无' ">{{shopDeviceSubNo.model || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>规格</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDeviceSubNo.fixedSpec || '无' ">{{shopDeviceSubNo.fixedSpec || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>商品标识码</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDeviceSubNo.vendorUkno || '无' ">{{shopDeviceSubNo.vendorUkno || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>特种设备</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.specialFlag ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>使用方式</label>
                    </div>
                    <div class="form-value">
                        <span>{{useMannerMap[shopDeviceSubNo.useManner] || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="infoType == null || infoType == 'change'">
                    <div class="form-label">
                        <label>创建时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.createTime || '无'}}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="singleTobObj.repairInfoFalg">
            <div class="content-caption dashed">
                <span>设备维保信息</span>
            </div>
            <div class="simple-form flex col-2">
                <div class="form-group center" v-if="infoType == null || infoType == 'change'">
                    <div class="form-label">
                        <label>保内</label>
                    </div>
                    <div class="form-value">
                        <span class="font-red" v-if="shopDeviceSubNo.wrntDueTime != null && new Date(shopDeviceSubNo.currentTime).getTime() > new Date(shopDeviceSubNo.wrntDueTime).getTime()">否</span>
                        <span class="font-green" v-if="shopDeviceSubNo.wrntDueTime == null || new Date(shopDeviceSubNo.currentTime).getTime() <= new Date(shopDeviceSubNo.wrntDueTime).getTime()">是</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>质保期(月)</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.wrntPeriod || '0'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>质保开始时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.wrntStartTime || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>质保到期时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.wrntDueTime || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="infoType == null || infoType == 'change'">
                    <div class="form-label">
                        <label>需巡查</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.patrolFlag ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="infoType == null || infoType == 'change'">
                    <div class="form-label">
                        <label>需保养</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.maintFlag ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="infoType == null || infoType == 'change'">
                    <div class="form-label">
                        <label>需要安装</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.setupFlag ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="infoType == null || infoType == 'change'">
                    <div class="form-label">
                        <label>需要控温</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDeviceSubNo.temperFlag ? '需要' : '不需要' ">{{shopDeviceSubNo.temperFlag ? '需要' : '不需要'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>故障次数</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.faultTimes || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>维修次数</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.repairTimes || '0'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>最近维保时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.lastRepairMainTime || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>延保单</label>
                    </div>
                    <div class="form-value">
                        <span v-if="shopDeviceSubNo.wrntExtVoucherId == -1">无</span>
                        <span v-else>{{shopDeviceSubNo.WrntExtVoucherNo || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="infoType == null || infoType == 'change'">
                    <div class="form-label">
                        <label>维保分组</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.devcGroupFullName || ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>定义描述全称</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.devcDefTitle || ''}}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="singleTobObj.manageInfoFalg">
            <div class="content-caption dashed">
                <span>设备保管信息</span>
            </div>
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label>业务单元</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.retailerBizUnitName || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>所在部门</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.retailerShopName || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>责任部门</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.departName || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>责任人</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.principalName || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>所在经度</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.lng || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>所在纬度</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.lat || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>账面不符</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.indoubtFlag == 1 ? '是' : '否'}}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="singleTobObj.useInfoFalg">
            <div class="content-caption dashed">
                <span>设备使用信息</span>
            </div>
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label>启用日期</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.initStartDate || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>机构启用日期</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.startDate || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产状态</label>
                    </div>
                    <div class="form-value">
                        <div v-if="shopDeviceSubNo.useState == inactiveValue">
                            <span class="font-black">未启用</span>
                        </div>
                        <div v-else-if="shopDeviceSubNo.useState == outageValue ">
                            <span class="font-gold">已停用</span>
                        </div>
                        <div v-else-if="shopDeviceSubNo.useState == startValue">
                            <span class="font-green">已启用</span>
                        </div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>运行状态</label>
                    </div>
                    <div class="form-value">
                        <span class="font-green" v-if="shopDeviceSubNo.state == 0">正常</span>
                        <span class="font-red" v-if="shopDeviceSubNo.state == 1">有故障</span>
                        <span class="font-black" v-if="shopDeviceSubNo.state == 2">已报修</span>
                        <span class="font-black" v-if="shopDeviceSubNo.state == 3">维修中</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>是否在用</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.inUse ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="infoType == null || infoType == 'change'">
                    <div class="form-label">
                        <label>是否在库</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.inStock ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>锁定</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.locked ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="infoType == null || infoType == 'change'">
                    <div class="form-label">
                        <label>最近操作时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.actTime || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="infoType == null || infoType == 'change'">
                    <div class="form-label">
                        <label>最近扫码时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.qrScanTime || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>领用部门</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.usagedDepartName || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>领用人</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.usagedStaffName || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>所属套装</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.suitName || "无"}}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="singleTobObj.devcStatisInfoFalg">
            <div class="content-caption dashed">
                <span>设备统计信息</span>
            </div>
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label>单位</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.theUnit || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>业务标签</label>
                    </div>
                    <div class="form-value">
                        <template v-for="tagName in shopDeviceSubNo.tagNames">
                            <span class="swb-tags swb-tags-success mr5">{{tagName}}</span>
                        </template>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>机构标签</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.retailerShopTagName || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>在库数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.inStock ? 1 : 0}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>机构使用时长(天)</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.startTimeDay || '0'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>机构停用时长(分)</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.outageTimeMi || '0'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>本次闲置时长(时)</label>
                    </div>
                    <div class="form-value">
                        <span>{{((shopDeviceSubNo.curIdleTimeMi || 0) / 60).toFixed(1)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>以前闲置时长(时)</label>
                    </div>
                    <div class="form-value">
                        <span>{{(shopDeviceSubNo.idleTimeMi / 60).toFixed(1)}}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="singleTobObj.assetBaseInfoFalg">
            <div class="content-caption dashed">
                <span>资产基础信息</span>
            </div>
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产编号</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.innerCode || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产属性</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetNatureMap[shopDeviceSubNo.assetNature] || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产分类</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.innerDevcCatName || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>外部系统编号</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDeviceSubNo.innerNo || '无' ">{{shopDeviceSubNo.innerNo || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>可出租</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.leasible ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>可拆分</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.splitible ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="infoType == 'fiscal'">
                    <div class="form-label">
                        <label>原始资产编码</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.initInnerCode || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>使用方式</label>
                    </div>
                    <div class="form-value">
                        <span>{{useMannerMap[shopDeviceSubNo.useManner] || '无'}}</span>
                    </div>
                </div>
                <!--<div class="form-group center" v-if="infoType == 'fiscal'">-->
                <!--<div class="form-label">-->
                <!--<label>未结算资产</label>-->
                <!--</div>-->
                <!--<div class="form-value">-->
                <!--<span>{{shopDeviceSubNo.outerUnsettled ? '是' : '否'}}</span>-->
                <!--</div>-->
                <!--</div>-->
            </div>
        </template>

        <template v-if="singleTobObj.financeInfoFalg">
            <div class="content-caption dashed">
                <span>资产台账信息</span>
            </div>
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label>折旧分摊规则编码</label>
                    </div>
                    <div class="form-value">
                        <span v-if="shopDeviceSubNo.deprSpecId != null && shopDeviceSubNo.deprSpecId != -1"><a class="table-cell-link" @click="showDeprSpec(shopDeviceSubNo.deprSpecId)">{{shopDeviceSubNo.deprSpecCode}}</a></span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>未税单价(元)</label>
                    </div>
                    <div class="form-value">
                        <span v-if="shopDeviceSubNo.ntxPrice != null">{{shopDeviceSubNo.ntxPrice.toFixed(2) || 0.00}}</span>
                        <span v-else>0.00</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>含税单价(元)</label>
                    </div>
                    <div class="form-value">
                        <span v-if="shopDeviceSubNo.price != null">{{shopDeviceSubNo.price.toFixed(2) || 0.00}}</span>
                        <span v-else>0.00</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>入账时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.fiscalInTime || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>入账方式</label>
                    </div>
                    <div class="form-value">
                        <span>{{acctEnterWayMap[shopDeviceSubNo.acctEnterWay]}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>预计使用年限（月）</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.durableLife || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>折旧方式</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDeprMethodMap[shopDeviceSubNo.deprMethodCode] || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>当次折旧金额（元）</label>
                    </div>
                    <div class="form-value">
                        <span v-if="shopDeviceSubNo.currentMonthDepr != null">{{shopDeviceSubNo.currentMonthDepr.toFixed(2)}}</span>
                        <span v-else>0.00</span>
                    </div>
                </div>
                <div class="form-group center" v-if="shopDeviceSubNo.fiscalAcctFlag == 1">
                    <div class="form-label">
                        <label>折旧完毕</label>
                    </div>
                    <div class="form-value">
                        <span class="font-red" v-if="shopDeviceSubNo.deprOver">是</span>
                        <span v-else>否</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>残值率(%)</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.rmnWorthRatio || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>原值(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.orgWorth == null ? '无' : shopDeviceSubNo.orgWorth.toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>净值(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.netWorth == null ? '无' : shopDeviceSubNo.netWorth.toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>最后折旧月份</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.lastDeprMonth || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>税率(%)</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.taxRate == null ? '无' : shopDeviceSubNo.taxRate.toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="shopDeviceSubNo.deprMethodCode == 'SLD' || shopDeviceSubNo.deprMethodCode == 'ASM'">
                    <div class="form-label">
                        <label>首次计提</label>
                    </div>
                    <div class="form-value">
                        <div class="form-value">
                            <span class="font-red" v-if="shopDeviceSubNo.cnt1stMonth">首月</span>
                            <span v-else>次月</span>
                        </div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>累计折旧金额（元）</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.aggtDeprWorth == null ? '无' : shopDeviceSubNo.aggtDeprWorth.toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>剩余折旧月数</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.leftMonths || 0}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>报废/弃用</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.scrapped ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>报废日期</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.scrapDate || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>清理日期</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.fiscalOutTime || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>清理原因</label>
                    </div>
                    <div class="form-value">
                        <span>{{devcClearCauseMap[shopDeviceSubNo.clearCause] || '无'}}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="singleTobObj.assetStatisInfoFalg">
            <div class="content-caption dashed">
                <span>资产统计信息</span>
            </div>
            <div class="simple-form flex col-2">
                <!--@杨红娜 - 两个费用已保存成其他费用，此处不展示-->
                <!--<div class="form-group center">-->
                <!--<div class="form-label">-->
                <!--<label>组装费用(元)</label>-->
                <!--</div>-->
                <!--<div class="form-value">-->
                <!--<span v-if="shopDeviceSubNo.asmblFee != null">{{shopDeviceSubNo.asmblFee.toFixed(2) || 0.00}}</span>-->
                <!--<span v-else>0.00</span>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="form-group center">-->
                <!--<div class="form-label">-->
                <!--<label>安装单价(元)</label>-->
                <!--</div>-->
                <!--<div class="form-value">-->
                <!--<span v-if="shopDeviceSubNo.setupPrice != null">{{shopDeviceSubNo.setupPrice.toFixed(2) || 0.00}}</span>-->
                <!--<span v-else>0.00</span>-->
                <!--</div>-->
                <!--</div>-->
                <div class="form-group center">
                    <div class="form-label">
                        <label>在账数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.fiscalAcctFlag || 0}}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="singleTobObj.srcInfoFalg">
            <div class="content-caption dashed">
                <span>来源信息</span>
            </div>
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label>批次号</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.batchNo || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>厂商序列号</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDeviceSubNo.vendorSn || '无' ">{{shopDeviceSubNo.vendorSn || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>统一商品代码(UPC)</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDeviceSubNo.upn || '无' ">{{shopDeviceSubNo.upn || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>卖家名称</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.sellerName || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>供商商户内部编码</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDeviceSubNo.innerVendorNo || '无' ">{{shopDeviceSubNo.innerVendorNo || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>初始合同编号</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.initContractNo || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>收货时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.receiveTime || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>导入</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDeviceSubNo.imported ? '是' : '否'}}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="singleTobObj.imgInfoFalg">
            <div class="content-caption dashed">
                <span>资产图片</span>
            </div>
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产图片</label>
                    </div>
                    <div class="form-value">
                        <div class="file-area clearfix" v-if="shopDeviceSubNo.imageUrl != null && shopDeviceSubNo.imageUrl.length > 0">
                            <div class="file-item image viewable downloadable">
                                <div class="file-content" @click="viewImage(shopDeviceSubNo.imageUrl)">
                                    <img :src="shopDeviceSubNo.imageUrl"/>
                                    <div class="operation-group">
                                        <i class="icon iconfont icon-chakan view"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <img v-resc-url="'/image/noimg.jpg'"/>
                        </div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>型号图片</label>
                    </div>
                    <div class="form-value">
                        <div class="file-area clearfix" v-if="shopDeviceSubNo.shopDevice != null && shopDeviceSubNo.shopDevice.imageUrl != null && shopDeviceSubNo.shopDevice.imageUrl != ''">
                            <div class="file-item image viewable downloadable">
                                <div class="file-content" @click="viewImage(shopDeviceSubNo.shopDevice.imageUrl)">
                                    <img :src="shopDeviceSubNo.shopDevice.imageUrl"/>
                                    <div class="operation-group">
                                        <i class="icon iconfont icon-chakan view"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <img v-resc-url="'/image/noimg.jpg'"/>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes, getComnMerchantBizTag } from '../../app.vues'
    import appConf from '../../app.conf';
    import { getDefaultPageSizes } from '../../app.conf'
    import { openBigImgDlg } from '../comn/dialog'
    import { openDeprSpecDetailDlg } from '../devcDef/showDlg'
    //
    import shopDevcApi from '../../api/shopDevc'
    import merchtComnApi from '../../api/merchtComn'

    import SwbDeviceMalfunctionStatisList from './DeviceMalfunctionStatisList.vue';
    Vue.regist(SwbDeviceMalfunctionStatisList);
    //
    let bizTagObj = null;
    export default {
        name: 'swb-shop-device-svc-sub-no-info',
        desc: '资产详情',
        props: ['svcSubNo', 'showSingleTobObj', 'infoType'],
        data: function () {
            return {
                // 所有的分组默认展示
                singleTobObj: {
                    devcBaseInfoFalg: true,
                    repairInfoFalg: true,
                    manageInfoFalg: true,
                    useInfoFalg: true,
                    devcStatisInfoFalg: true,
                    srcInfoFalg: true,
                    assetBaseInfoFalg: true,
                    financeInfoFalg: true,
                    assetStatisInfoFalg: true,
                    imgInfoFalg: true,
                },
                shopDeviceSubNo: {},
                startValue: getEnumInfoWith('deviceUseState', 'name', 'Start').value,
                outageValue: getEnumInfoWith('deviceUseState', 'name', 'Outage').value,
                inactiveValue: getEnumInfoWith('deviceUseState', 'name', 'Inactive').value,
                // 入账方式
                acctEnterWayMap: getEnumMap("acctEnterWay", "value2text"),
                devcClearCauseMap: getEnumMap("devcClearCause", "value2text"),
                assetDeprMethodMap: getEnumMap("assetDeprMethod", "name2text"),
                assetNatureMap: getEnumMap("assetNature", "value2text"),
                useMannerMap: getEnumMap("devcUseManner", "value2text"),
            }
        },
        created: function () {
            // 处理分组显示
            let showSingleTobObj = this.showSingleTobObj;
            if(!Utils.isNoB(showSingleTobObj)) {
                let singleTobObj = this.singleTobObj;
                for(let key in showSingleTobObj) {
                    singleTobObj[key] = showSingleTobObj[key];
                }
                this.singleTobObj = Utils.merge({}, singleTobObj);
            }
            bizTagObj = getComnMerchantBizTag();
            //
            this.getShopDeviceSvcSubNo();
        },
        methods: {
            getShopDeviceSvcSubNo: function () {
                let self = this;
                let postData = {};
                postData.id = self.svcSubNo.id;
                let theLoad = MsgBox.loading();
                shopDevcApi.getShopDeviceSvcSubNo(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let shopDeviceSubNo = result.data || {};
                        //
                        if(!Utils.isNoB(shopDeviceSubNo.bizTag)) {
                            self.makeBizTag(shopDeviceSubNo);
                        }
                        //
                        self.shopDeviceSubNo = shopDeviceSubNo;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            makeBizTag: function (shopDeviceSubNo) {
                let bizTag = shopDeviceSubNo.bizTag;
                let tagIdList = [];
                if(!Utils.isNoB(bizTag)) {
                    if(bizTag.indexOf("|") >= 0) {
                        bizTag = bizTag.substring(1, bizTag.length - 1);
                        tagIdList = bizTag.split("|") || [];
                    } else {
                        tagIdList.push(bizTag);
                    }
                }
                let tagNames = [];
                for(let i = 0; i < tagIdList.length; i++) {
                    let tagId = tagIdList[i];
                    let tagName = bizTagObj.getBizTagNameById(tagId);
                    if(!Utils.isNoB(tagName)) {
                        tagNames.push(tagName);
                    }
                }
                shopDeviceSubNo.tagNames = tagNames;
            },
            //
            viewImage: function (fileBrowseUrl) {
                openBigImgDlg(fileBrowseUrl);
            },
            showDeprSpec(deprSpecId){
                openDeprSpecDetailDlg(deprSpecId);
            }
        }
    }
</script>
<style>
    .form-row.col .form-label {
        width: 126px;
    }
</style>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceSvcSubNoInfo.vue